import {Column} from "primereact/column";
import React, {useState} from "react";
import {RadioButton} from "primereact/radiobutton";
import {filterNameConcat} from "../utils/PlaylistHelper";
import {Dialog} from "primereact/dialog";
import {AutoComplete} from "primereact/autocomplete";
import {Button} from "primereact/button";
import {InputNumber} from "primereact/inputnumber";

export default function SongSelector({songs, onSelectionConfirmed, header, dialogText, visible, setVisible, selectedNrReps = null, setSelectedNrReps = null, minNrReps = 1}) {
    const [filteredSongs, setFilteredSongs] = useState([]);
    const [selectedSong, setSelectedSong] = useState(null);

    const searchSong = (event) => {
        setTimeout(() => {
            let _filteredSongs;
            if (!event.query.trim().length) {
                _filteredSongs = [...songs];
            }
            else {
                _filteredSongs = songs.filter((song) => {
                    return filterNameConcat(event, song.nameconcat);
                });
            }

            setFilteredSongs(_filteredSongs);
        }, 250);
    }

    const itemTemplate = (item) => {
        return (
            <div className="song-item">
                <img src={`${item.image_url}`} width="16" height="16"/>
                <span> {item.nameconcat}</span>
            </div>
        );
    }
    const repetitionSelector = () => {
        if(selectedNrReps === null) {
            return;
        } else {
            return(<InputNumber
                value={selectedNrReps} onValueChange={(e) => setSelectedNrReps(e.value)}
                showButtons
                buttonLayout="horizontal"
                mode="decimal" min={minNrReps} max={50} step={1}/>)
        }

    }

    return(
        <Dialog header={header} visible={visible} onHide={() => {if (!visible) return; setVisible(false); }}>
            <div className="mb-2">
                { dialogText }
                <div  className = "gap-1 mt-2">
                    <AutoComplete
                        value={selectedSong}
                        suggestions={filteredSongs}
                        completeMethod={searchSong}
                        field="nameconcat" dropdown
                        placeholder="Select a song"
                        itemTemplate={itemTemplate}
                        onChange={(e) => setSelectedSong(e.value)}
                        aria-label="Songs" dropdownAriaLabel="Select Song"
                        style={{width: '290px'}}/>
                    {repetitionSelector()}
                </div>
            </div>
            <Button disabled={selectedSong === null} label={"Confirm"} onClick={() => {onSelectionConfirmed(selectedSong); setSelectedSong(null)}}/>
        </Dialog>
    )
}